module.exports = __webpack_public_path__ + "fonts/InstagramSans-Regular.a6fd005c.eot";